import React, { useState } from 'react';
// pages/Login.tsx
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import Button from '../components/ui/Button';
import Alert from '../components/ui/Alert';
import packageJson from '../../package.json';

const Login: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const {
    user,
    loading,
    loginWithMicrosoft
  } = useAuth();

  // If user is already logged in, redirect to dashboard
  if (user && !loading) {
    return <Navigate to="/dashboard" replace />;
  }
  const handleMicrosoftLogin = async () => {
    setError(null);
    setIsLoading(true);

    try {
      await loginWithMicrosoft();
      // Navigation is handled in the auth context after a successful login.
    } catch (err) {
      if (err instanceof Error) {
        setError(`Sign-in failed: ${err.message}`);
      } else {
        setError('An unknown error occurred during sign-in. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-50 p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-e3 overflow-hidden border border-ink-200">
          {/* Navy masthead with the serif wordmark and a hairline of gold */}
          <div className="bg-navy-900 px-8 pt-10 pb-8 text-center border-b-2 border-gold-400">
            <img src="/logo/pit-mark-reversed.svg" alt="" className="h-14 w-14 mx-auto mb-4" />
            <h1 className="font-serif text-page-title text-white leading-none">PIT</h1>
            <p className="text-body-sm text-navy-100 mt-2">Preferences · Intentions · Timetabling</p>
          </div>

          {/* Sign-in */}
          <div className="px-8 py-8">
            <p className="text-body text-ink-700 text-center mb-6">
              Sign in with your school account to continue.
            </p>

            {error && (
              <Alert tone="danger" className="mb-6">{error}</Alert>
            )}

            <Button
              type="button"
              variant="primary"
              className="w-full flex items-center justify-center gap-2 py-3"
              onClick={handleMicrosoftLogin}
              disabled={isLoading}
              isLoading={isLoading}
            >
              <span>{isLoading ? 'Signing in…' : 'Sign in with Microsoft'}</span>
            </Button>
            <p className="text-center text-meta text-ink-400 mt-4">
              Secure single sign-on. No password required.
            </p>
          </div>
        </div>

        <p className="text-center text-meta text-ink-400 mt-6 font-mono tabular-nums">
          Version {packageJson.version}
        </p>
      </div>
    </div>
  );
};
export default Login;
